<!-- <dx-load-panel [visible]="(loading$ | async) || false" shadingColor="rgba(0,0,0,0.4)" [showIndicator]="true"
  [showPane]="true" [shading]="true">
</dx-load-panel> -->

<!-- // old Loader code -->
<!-- <dx-load-panel class="global-loader white-blue-loader" [visible]="(loading$ | async) || false"
  shadingColor="rgba(0,0,0,0.4)" [showIndicator]="true" [showPane]="true" [shading]="true">
</dx-load-panel> -->


<!-- // New Loader code -->
<div class="app-loader-overlay" *ngIf="loading$ | async"> 
  <div class="app-loader">

    <div class="app-loader__stage">
      <!-- expanding ripples -->
      <span class="app-loader__ripple"></span>
      <span class="app-loader__ripple r2"></span>
      <span class="app-loader__ripple r3"></span>

      <!-- rotating orbit -->
      <svg class="app-loader__orbit" viewBox="0 0 100 100" aria-hidden="true">
        <path d="M 97 50 A 47 47 0 0 1 16.77 83.23" class="lead" />
        <path d="M 8.12 28.66 A 47 47 0 0 1 57.34 3.59" class="trail" />
        <circle cx="16.77" cy="83.23" r="2.2" class="dot" />
      </svg>

      <!-- centre avatar -->
      <div class="app-loader__avatar">
        <img src="assets/icons/mother_baby_loader2.png" alt="Loading" />
      </div>
    </div>

    <!-- Optional message under the loader. Shows only if loaderText has a value. -->
    <div class="app-loader__text" *ngIf="loaderText">{{ loaderText }}</div>
  </div>


</div> 




<ng-container *ngIf="!isAuthPage(); else unauthenticated">
  <app-side-nav-inner-toolbar title="{{appInfo.title}}">
    <router-outlet></router-outlet>
  </app-side-nav-inner-toolbar>
</ng-container>

<ng-template #unauthenticated>
  <app-unauthenticated-content></app-unauthenticated-content>
</ng-template>